import { onlyStringNumber } from '../../../regex';

const requis = '^Ce champ est requis';
const maxMessage = 'Le champ ne doit pas contenir plus de ';

export const formUpdateClassObjectiveSchema = {
  name: {
    presence: { allowEmpty: false, message: requis },
    length: {
      maximum: 80,
      message: `^${maxMessage} 80 caractères`
    }
  },
  ca: {
    presence: { allowEmpty: false, message: requis },
    length: {
      maximum: 6,
      message: `^${maxMessage} 6 caractères`
    },
    format: {
      pattern: onlyStringNumber,
      message: `^Le CA doit comporter uniquement des chiffres`
    }
  }
};
